import React from 'react';
import { HyperText } from '../components/HyperText';
import { MapPinIcon, PhoneIcon, MailIcon, ExternalLinkIcon } from 'lucide-react';
const ContactPage = () => {
  return <div className="w-full bg-white" data-id="element-429">
      <div className="pt-40 sm:pt-48 md:pt-56 pb-12 sm:pb-16 md:pb-24" data-id="element-430">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 text-center tracking-normal px-4" data-id="element-431">
          Contact Us
        </h1>
      </div>
      <div className="py-12 sm:py-16 md:py-24" data-id="element-432">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-433">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 sm:gap-16" data-id="element-434">
            <div data-id="element-435">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8 sm:mb-10 tracking-normal" data-id="element-436">
                Get In Touch
              </h2>
              <div className="mb-12" data-id="element-437">
                <div className="flex items-start gap-4 mb-8" data-id="element-438">
                  <MapPinIcon className="w-6 h-6 sm:w-7 sm:h-7 text-blue-500 flex-shrink-0 mt-1" data-id="element-439" />
                  <div data-id="element-440">
                    <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 tracking-normal" data-id="element-441">
                      Israeli Civilian Training Fund (ICTF)
                    </h3>
                  </div>
                </div>
              </div>
              <div className="bg-blue-50 p-8" data-id="element-442">
                <h3 className="text-xl font-semibold text-gray-900 mb-6 tracking-normal" data-id="element-443">
                  How You Can Help
                </h3>
                <ul className="space-y-4" data-id="element-444">
                  <li className="flex items-start" data-id="element-445">
                    <span className="font-semibold text-blue-500 mr-2" data-id="element-446">
                      Give
                    </span>
                    <span className="text-gray-700" data-id="element-447">
                      Tax-deductible gifts through our U.S. 501(c)(3) Israeli
                      Civilian Training Fund{' '}
                      <span className="text-sm italic" data-id="element-448"></span>.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-449">
                    <span className="font-semibold text-blue-500 mr-2" data-id="element-450">
                      Partner
                    </span>
                    <span className="text-gray-700" data-id="element-451">
                      Introduce corporate grants or in-kind equipment.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-452">
                    <span className="font-semibold text-blue-500 mr-2" data-id="element-453">
                      Share
                    </span>
                    <span className="text-gray-700" data-id="element-454">
                      Host an awareness event or share our story online.
                    </span>
                  </li>
                </ul>
                <div className="mt-8" data-id="element-455">
                  <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors w-full text-center" data-id="element-456">
                    Donate Now
                  </a>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-8 sm:p-10 flex flex-col justify-center" data-id="element-457">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 tracking-normal" data-id="element-458">
                Send Us a Message
              </h2>
              <p className="text-gray-700 text-base sm:text-lg mb-8 leading-relaxed" data-id="element-459">
                We'd love to hear from you. Click below to fill out our contact
                form and a member of our team will get back to you shortly.
              </p>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSd9WG42NcqW986ZXrVXt9w3yqegr-291VjOSCMUA-aSkzYx9A/viewform?usp=publish-editor" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-4 bg-israel-blue text-white font-semibold rounded-lg hover:bg-israel-blue-light transition-colors text-lg shadow-md w-full sm:w-auto" data-id="element-460">
                Open Contact Form
                <ExternalLinkIcon className="ml-2 w-5 h-5" data-id="element-461" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactPage;